import { render, staticRenderFns } from "./FeedbackListView.vue?vue&type=template&id=6a39c9a3&scoped=true&"
import script from "./FeedbackListView.vue?vue&type=script&lang=ts&"
export * from "./FeedbackListView.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackListView.vue?vue&type=style&index=0&id=6a39c9a3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a39c9a3",
  null
  
)

export default component.exports